const actionTypes = {
  loginTypes: {
    PRE_LOGIN: "PRE_LOGIN",
    SET_PRE_LOGIN_LOADER: "SET_PRE_LOGIN_LOADER",
    LOGIN: "LOGIN",
    SET_LOGIN_LOADER: "SET_LOGIN_LOADER",
    LOGOUT: "LOGOUT",
    SET_REQUEST_NEW_PASSWORD_LOADER: "SET_REQUEST_NEW_PASSWORD_LOADER",
    SET_CHANGE_PASSWORD_LOADER: "SET_CHANGE_PASSWORD_LOADER",
    LAST_LOGIN_TIME: "LAST_LOGIN_TIME",
  },
  header: {
    SET_MY_PROFILE_LOADER: "SET_MY_PROFILE_LOADER",
  },
  adminTypes: {
    GET_SEARCH_USERS: "GET_SEARCH_USERS",
    organizationSettingTypes: {
      SET_UPLOAD_CSV_LOADER: "SET_UPLOAD_CSV_LOADER",
      GET_PASSWORD_EXPIRY_LOADER: "GET_PASSWORD_EXPIRY_LOADER",
      SET_PASSWORD_EXPIRY_LOADER: "SET_PASSWORD_EXPIRY_LOADER",
      GET_USER_EMAIL_DETAILS_LOADER: "GET_USER_EMAIL_DETAILS_LOADER",
      ADD_USER_EMAIL_DETAILS_LOADER: "ADD_USER_EMAIL_DETAILS_LOADER",
    },
    rolesAndPermissionsTypes: {
      SET_ROLES_AND_PERMISSIONS: "SET_ROLES_AND_PERMISSIONS",
      SET_POST_ROLE_LOADER: "SET_POST_ROLE_LOADER",
      SET_CREATE_ROLE_LOADER: "SET_CREATE_ROLE_LOADER",
      SET_ROLE_NAME_CHECK_LOADER: "SET_ROLE_NAME_CHECK_LOADER",
    },
    assignUsersToROles: {
      GET_USERS_ROLES: "GET_USERS_ROLES",
      post_ASSIGN_USER_TO_ROLES: "post_ASSIGN_USER_TO_ROLES",
    },
    userManagementTypes: {
      UNLOCK_USER_ACCOUNT_LOADER: "UNLOCK_USER_ACCOUNT_LOADER",
      TOGGLE_USER_STATUS_LOADER: "TOGGLE_USER_STATUS_LOADER",
      IS_LOGINID_EXISTS_LOADER: "IS_LOGINID_EXISTS_LOADER",
      GET_COUNTRY_LIST_LOADER: "GET_COUNTRY_LIST_LOADER",
      GET_STATE_LIST_LOADER: "GET_STATE_LIST_LOADER",
      GET_CITY_LIST_LOADER: "GET_CITY_LIST_LOADER",
      GET_WORK_OFFICE_LIST_LOADER: "GET_WORK_OFFICE_LIST_LOADER",
      GET_PRODUCT_CATEGORY_LIST_LOADER: "GET_PRODUCT_CATEGORY_LIST_LOADER",
      GET_USER_GROUPS_LOADER: "GET_USER_GROUPS_LOADER",
      GET_ALL_ROLES_LOADER: "GET_ALL_ROLES_LOADER",
      POST_USER_PROFILE_LOADER: "POST_USER_PROFILE_LOADER",
      PUT_USER_PROFILE_LOADER: "PUT_USER_PROFILE_LOADER",
    },
    certificateManagementTypes: {
      DELETE_CERTIFICATE_LOADER: "DELETE_CERTIFICATE_LOADER",
      UPLOAD_CERTIFICATE_LOADER: "UPLOAD_CERTIFICATE_LOADER",
      POST_NEW_CERTIFICATE_LOADER: "POST_NEW_CERTIFICATE_LOADER",
      POST_EDIT_CERTIFICATE_LOADER: "POST_EDIT_CERTIFICATE_LOADER",
    },
    emailTrigger: {
      SEND_TO_QUEUE: "SEND_TO_QUEUE",
    },
    groupManagement: {
      GET_CLASSES_OR_SERIES: "GET_CLASSES_OR_SERIES",
      DELETE_MANADATED_CLASS: "DELETE_MANADATED_CLASS",
      MANAGE_USERS_COUNT: "MANAGE_USERS_COUNT",
      MANAGE_SUBGROUPS_COUNT: "MANAGE_SUBGROUPS_COUNT",
    },
    myQueries: {
      GET_ALL_ASSIGNED_QUERIES: "GET_ALL_ASSIGNED_QUERIES",
      GET_ALL_ASSIGNED_QUERIES_SUPPORT_TAB:
        "GET_ALL_ASSIGNED_QUERIES_SUPPORT_TAB",
      PUT_QUERY: "PUT_QUERY",
      PUT_UNREAD_COUNT: "PUT_UNREAD_COUNT",
      PUT_IS_READ: "PUT_IS_READ",
    },
    engagementCenter: {
      TRIGGER_NOTIFICATION_LOADER: "TRIGGER_NOTIFICATION_LOADER",
      DELETE_NOTIFICATION_LOADER: "DELETE_NOTIFICATION_LOADER",
    },
  },
  commonTypes: {
    SET_TENANT_NAME: "SET_TENANT_NAME",
    SIDEBAR_TOGGLE: "SIDEBAR_TOGGLE",
    SET_LANGUAGE: "SET_LANGUAGE",
    SET_PAGE_LOADER: "SET_PAGE_LOADER",
    GET_MY_PROFILE: "GET_MY_PROFILE",
    UPDATE_MY_PROFILE: "UPDATE_MY_PROFILE",
    RESET_PASSWORD: "RESET_PASSWORD",
    POST_CONTACT_US_NEW_COMPLAINT: "POST_CONTACT_US_NEW_COMPLAINT",
    SET_THEME_STYLES: "SET_THEME_STYLES",
    SET_USER_ROLE_MENU: "SET_USER_ROLE_MENU",
    GET_TENANT_PERMISSION_INFO: "GET_TENANT_PERMISSION_INFO",
  },
  errorTypes: {
    SET_ERROR: "SET_ERROR",
    UNSET_ERROR: "UNSET_ERROR",
    API_ERROR: "API_ERROR",
    SET_LOADING: "SET_LOADING",
    UNSET_LOADING: "UNSET_LOADING",
  },
  manageTypes: {
    //manage page
    GET_MY_DRAFTS: "GET_MY_DRAFTS",
    GET_PUBLISHED_BY_ME: "GET_PUBLISHED_BY_ME",
    GET_PUBLISHED_BY_OTHERS: "GET_PUBLISHED_BY_OTHERS",
    GET_TRANSCRIPTION_DETAILS: "GET_TRANSCRIPTION_DETAILS",
    DELETE_SHOTCLASS_LOADER: "DELETE_SHOTCLASS_LOADER",

    GET_CLASS_DETAILS_BY_ID: "GET_CLASS_DETAILS_BY_ID",
    RESET_MY_DRAFTS_COUNT: "RESET_MY_DRAFTS_COUNT",

    //create shotclass
    SET_GET_LANGUAGES_LOADER: "SET_GET_LANGUAGES_LOADER",
    SET_GET_TRAININGS_LOADER: "SET_GET_TRAININGS_LOADER",
    SET_GET_SHOTCLASS_TAG_LOADER: "SET_GET_SHOTCLASS_TAG_LOADER",
    SET_IS_SHOTCLASS_NAME_EXIST_LOADER: "SET_IS_SHOTCLASS_NAME_EXIST_LOADER",
    SET_SAVE_AS_A_DRAFT_LOADER: "SET_SAVE_AS_A_DRAFT_LOADER",
    SET_SHOTCLASS_PUBLISH_LOADER: "SET_SHOTCLASS_PUBLISH_LOADER",
    SET_GET_USER_GROUPS_LOADER: "SET_GET_USER_GROUPS_LOADER",
    //->sub
    SET_GET_YOUTUBE_VIDEOS_LOADER: "SET_GET_YOUTUBE_VIDEOS_LOADER",
    SET_GET_ONLINE_COURSES_LOADER: "SET_GET_ONLINE_COURSES_LOADER",
    SET_GET_SLIDESHARES_LOADER: "SET_GET_SLIDESHARES_LOADER",

    SET_UPDATE_VIDEO_LIST: "SET_UPDATE_VIDEO_LIST",
    SET_SHOW_VIDEO_UPLOAD_LIST_PANEL: "SET_SHOW_VIDEO_UPLOAD_LIST_PANEL",

    //create training type
    SET_ADD_TRAINING_LOADER: "SET_ADD_TRAINING_LOADER",
    SET_DELETE_TRAINING_LOADER: "SET_DELETE_TRAINING_LOADER",
    //content bulk upload
    SET_BULK_UPLOAD_CSV_LOADER: "SET_BULK_UPLOAD_CSV_LOADER",
    SET_UPLOAD_QUIZ_IMAGES_LOADER: "SET_UPLOAD_QUIZ_IMAGES_LOADER",
    SET_DELETE_QUIZ_IMAGES_LOADER: "SET_DELETE_QUIZ_IMAGES_LOADER",

    //transcription
    SET_GET_TRANSCRIPTION_DATA_LOADER: "SET_GET_TRANSCRIPTION_DATA_LOADER",
    SET_ADD_TRANSCRIBE_TAG_LOADER: "SET_ADD_TRANSCRIBE_TAG_LOADER",
  },
  eventTypes: {
    EVENT_GET_MY_DRAFTS: "EVENT_GET_MY_DRAFTS",
    EVENT_PUBLISHED_BY_ME: "EVENT_PUBLISHED_BY_ME",
    EVENT_PUBLISHED_BY_OTHERS: "EVENT_PUBLISHED_BY_OTHERS",
    POST_LIVE_QUIZ_EVENT: "POST_LIVE_QUIZ_EVENT",
    GET_CLASS_BY_TAGS_LiveTraining: "GET_CLASS_BY_TAGS_LiveTraining",
    GET_CLASS_BY_TAGS_VirtualTraining: "GET_CLASS_BY_TAGS_VirtualTraining",
    EVENT_ADD_QUIZ_IMAGE: "EVENT_ADD_QUIZ_IMAGE",
  },

  organizeTypes: {
    SHOTCLASS_DATA: "SHOTCLASS_DATA",
    PROGRAM_DATA: "PROGRAM_DATA",
    SERIES_SHOTCLASS_DATA: "SERIES_SHOTCLASS_DATA",
    GET_CLASS_COLLECTION_DATA: "GET_CLASS_COLLECTION_DATA",
    CONTENT_DATA: "CONTENT_DATA",
  },

  socialTypes: {
    GET_MY_POLLS: "GET_MY_POLLS",
    GET_ALL_POLLS: "GET_ALL_POLLS",
    EDIT_POLL_RESPONSE: "EDIT_POLL_RESPONSE",
    COPY_POLL_RESPONSE: "COPY_POLL_RESPONSE",
    DISTRIBUTE_POLL_RESPONSE: "DISTRIBUTE_POLL_RESPONSE",
    GET_TENANT_POLL_USERS: "GET_TENANT_POLL_USERS",
    GET_POLL_USER_GROUP: "GET_POLL_USER_GROUP",
    GET_POLL_PREVIEW_LIST: "PREVIEW_LIST",
    SET_POLL_LOADER: "SET_POLL_LOADER",
    SET_LOCK_POLL_LOADER: "SET_LOCK_POLL_LOADER",
    SET_UNLOCK_POLL_LOADER: "SET_UNLOCK_POLL_LOADER",
    SET_DELETE_POLL_LOADER: "SET_DELETE_POLL_LOADER",
    SET_DISTRIBUTE_POLL_LOADER: "SET_DISTRIBUTE_POLL_LOADER",
    SET_IS_POLL_NAME_EXIST_LOADER: "SET_IS_POLL_NAME_EXIST_LOADER",
    FORUM_AREA: {
      CREATE_FORUM_TOPIC_RESPONSE: "CREATE_FORUM_TOPIC_RESPONSE",
      CREATE_FORUM_TOPIC_LOADING: "CREATE_FORUM_TOPIC_LOADING",
      EDIT_FORUM_TOPIC_RESPONSE: "EDIT_FORUM_TOPIC_RESPONSE",
      CREATE_FORUMT_THREAD: "CREATE_FORUMT_THREAD",
      FORUM_TOPICS: "FORUM_TOPICS",
      CREATE_FORUM_THREAD_LOADER: "CREATE_FORUM_THREAD_LOADER",
      FORUM_THREADS: "FORUM_THREADS",
      CREATE_FORUM_COMMENT_LOADER: "CREATE_FORUM_COMMENT_LOADER",
      VIEW_COMMENTS: "VIEW_COMMENTS",
      SHOTCLASS_FORM_DATA: "SHOTCLASS_FORM_DATA",
      SET_FORUM_TOPIC_LOADER: "SET_FORUM_TOPIC_LOADER",
    },
  },
  reportTypes: {
    commonTypes: {
      GET_TENANT_USERS: "GET_TENANT_USERS",
      GET_TRAINING_TYPES: "GET_TRAINING_TYPES",
      GET_CLASS_NAME: "GET_CLASS_NAME",
      GET_USER_GROUP: "GET_USER_GROUP",
    },

    graphicalReportTypes: {
      GET_USER_VISUAL_REPORT: "GET_USER_VISUAL_REPORT",
      GET_USER_DISTRIBUTION_SUMMARY: "GET_USER_DISTRIBUTION_SUMMARY",
      GET_CLASS_DISTRIBUTION_SUMMARY: "GET_CLASS_DISTRIBUTION_SUMMARY",
      GET_CLASS_VISUAL_REPORT: "GET_CLASS_VISUAL_REPORT",

      GET_ASSIGNED_CLASS: "GET_ASSIGNED_CLASS",
      FILTER_USER_DISTRIBUTION_SUMMARY: "FILTER_USER_DISTRIBUTION_SUMMARY",
      FILTER_USER_VISUAL_REPORT: "FILTER_USER_VISUAL_REPORT",
      FILTER_CLASS_DISTRIBUTION_SUMMARY: "FILTER_CLASS_DISTRIBUTION_SUMMARY",
      FILTER_CLASS_VISUAL_REPORT: "FILTER_CLASS_VISUAL_REPORT",
    },
    tabularReportTypes: {
      GET_USER_DISTRIBUTION_REPORT: "GET_USER_DISTRIBUTION_REPORT",
      GET_CLASS_DISTRIBUTION_REPORT: "GET_CLASS_DISTRIBUTION_REPORT",
      GET_USER_SHOTCLASS_REPORT: "GET_USER_SHOTCLASS_REPORT",
      GET_SHOTCLASS_USER_REPORT: "GET_SHOTCLASS_USER_REPORT",
      GET_COUNTRY_LIST: "GET_COUNTRY_LIST",
      GET_STATE_LIST: "GET_STATE_LIST",
      GET_CITY_LIST: "GET_CITY_LIST",
      GET_WORK_OFFICE_LIST: "GET_WORK_OFFICE_LIST",
      GET_PRODUCT_CATEGORY_LIST: "GET_PRODUCT_CATEGORY_LIST",
      GET_USER_CLASS_COMPLETION_REPORT: "GET_USER_CLASS_COMPLETION_REPORT",
      GET_USER_CLASS_COMPLETION_GRAPH_REPORT:
        "GET_USER_CLASS_COMPLETION_GRAPH_REPORT",
      GET_SEARCH_CLASS_NAME: "GET_SEARCH_CLASS_NAME",
      SEND_RAMAINDER: "SEND_REMAINDER",
      GET_SEARCH_USER_GROUP: "GET_SEARCH_USER_GROUP",
      GET_USER_REPORT: "GET_USER_REPORT",
      GET_USER_DISTRIBUTION_CSV_REPORT: "GET_USER_DISTRIBUTION_CSV_REPORT",
    },
    analyticalReportTypes: {
      GET_DEFAULT_SHOTCLASS_INFORMATION: "GET_DEFAULT_SHOTCLASS_INFORMATION",
    },
    surveyReportTypes: {
      GET_SURVEY_REPORT: "GET_SURVEY_REPORT",
      GET_CLASSES_WITH_SURVEY: "GET_CLASSES_WITH_SURVEY",
      GET_CLASSES_WITH_SCORED_SURVEY: "GET_CLASSES_WITH_SCORED_SURVEY",
    },
    quizReportTypes: {
      GET_QUIZ_REPORT: "GET_QUIZ_REPORT",
      GET_DRILLDOWN_QUIZ_REPORT: "GET_DRILDOWN_QUIZ_REPORT",
      GET_USER_RESPONSE_TO_QUESTIONS: "GET_USER_RESPONSE_TO_QUESTIONS",
    },
    accessReportTypes: {
      GET_ACCESS_REPORT: "GET_ACCESS_REPORT",
      GET_APPLICATION_ACCESS_USER_DETAILS:
        "GET_APPLICATION_ACCESS_USER_DETAILS",
    },
    adoptionReportTypes: {
      GET_TOTAL_ACTIVE_USERS: "GET_TOTAL_ACTIVE_USERS",
      GET_MOBILE_INSTALLATION_COUNT: "GET_MOBILE_INSTALLATION_COUNT",
      GET_USERGROUP_ACCESS_DETAILS: "GET_USERGROUP_ACCESS_DETAILS",
      GET_USERGROUP_CLASS_USAGE_DETAILS: "GET_USERGROUP_CLASS_USAGE_DETAILS",
      GET_SHOTCLASS_COMPLETION_TREND: "GET_SHOTCLASS_COMPLETION_TREND",
      GET_CLASS_WISE_USAGE_DETAILS: "GET_CLASS_WISE_USAGE_DETAILS",
      GET_NUMBER_OF_USER_ACCESSED_SHOTCLASS_APPLICATION:
        "GET_NUMBER_OF_USER_ACCESSED_SHOTCLASS_APPLICATION",
      GET_NUMBER_OF_USER_ACCESSED_SHOTCLASSESS:
        "GET_NUMBER_OF_USER_ACCESSED_SHOTCLASSESS",
      GET_MOBILE_APP_INSTALLATION_COUNT: "GET_MOBILE_APP_INSTALLATION_COUNT",
    },
  },
  distributeTypes: {
    SHOTCLASS_DATA: "SHOTCLASS_DATA",
    SERIES_DATA: "SERIES_DATA",
    COLLECTION_DATA: "COLLECTION_DATA",
    SELECTED_SHOTCLASS_DATA: "SELECTED_SHOTCLASS_DATA",
    SELECTED_COLLECTION_DATA: "SELECTED_COLLECTION_DATA",
    SELECTED_SERIES_DATA: "SELECTED_SERIES_DATA",
    CLASS_AND_COLLECTION_BY_PROGRAM_ID: "CLASS_AND_COLLECTION_BY_PROGRAM_ID",
    CERTIFICATE_BY_PROGRAM_ID: `CERTIFICATE_PROGRAM_ID`,
    ALL_CLASS_NAMES: "ALL_CLASS_NAMES",
  },
};
export default actionTypes;
